import { Call } from './Base.js';


var init = function (config) {

  for (var prop in config) {
    if (config.hasOwnProperty(prop)) {
      defaults[prop] = config[prop];
    }
  }

}

var getNewsFeeds = function () {
  return Call(window.host + window.kunde + "/newsfeed/GetNewsfeeds", {
    method: "GET",
    data: {

    }
  });
}

var getNewsItem = function (newsId) {
  return Call(window.host + window.kunde + "/newsfeed/GetNewsItem", {
    method: "GET",
    data: {
      cmsId: newsId
    }
  });
}

var getNumberOfNewNewsItem = function (newsId) {
  return Call(window.host + window.kunde + "/newsfeed/GetNewNewsitems", {
    method: "GET",
    data: {

    }
  });
}

var getNewsIsReadStatus = function (login) {
  return Call(window.host + window.kunde + "/newsfeed/GetNewsIsReadStatus?kunde=" + kunde + "&login=" + login, {
    method: "GET",
  })
}

var updateNewsIsReadStatus = function (id, login) {
  return Call(window.host + window.kunde + "/newsfeed/UpdateNewsIsReadStatus?kunde=" + kunde + "&login=" + login, {
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify({
      UmbracoNodeId: id,
      IsRead: 1
    })
  })
}

var searchSupport = function (term) {
  return Call(window.host + window.kunde + "/newsfeed/SearchSupport", {
    method: "GET",
    data: {
      searchterm: term
    }
  });
}

var readAllNews = function (login, ids) {
  return Call(window.host + window.kunde + "/newsfeed/ReadAllNews?kunde=" + window.kunde + "&login=" + login, {
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify({
      UmbracoNodeIds: ids,
    })
  })
}



export const Init = init;
export const GetNewsFeeds = getNewsFeeds;
export const GetNewsItem = getNewsItem;
export const GetNumberOfNewNewsItem = getNumberOfNewNewsItem;
export const GetNewsIsReadStatus = getNewsIsReadStatus;
export const UpdateNewsIsReadStatus = updateNewsIsReadStatus;
export const SearchSupport = searchSupport;
export const ReadAllNews = readAllNews;